module.exports = __webpack_public_path__ + "static/media/logo.8ef367b4.png";